const initial = () => {
    $('body').on('change', '.form-select', function() {
        const $this = $(this);
        // Update if "0" will be required value
        if ($this.val() === '0') {
            $this.addClass('empty');
        } else {
            $this.removeClass('empty');
        }
    });
    $('.form-select').change();
};

export default initial;
